import { useCallback } from 'react';

import type { CreateUnderwriterEmployeeInput } from '../../../../../../graphql';
import {
  useSalesCoverage_AdminCreateUnderwriterEmployeeMutation,
  useSalesCoverage_CreateUnderwriterEmployeeMutation,
} from '../graphql/__generated__';

export function useCreateUnderwriterEmployee(tenantId?: string) {
  const [createUnderwriterEmployeeAsCustomer, { error: errorAsCustomer }] =
    useSalesCoverage_CreateUnderwriterEmployeeMutation();
  const [createUnderwriterEmployeeAsAdmin, { error: errorAsAdmin }] =
    useSalesCoverage_AdminCreateUnderwriterEmployeeMutation();

  const createUnderwriterEmployee = useCallback(
    async (input: CreateUnderwriterEmployeeInput) => {
      if (tenantId) {
        const response = await createUnderwriterEmployeeAsAdmin({
          variables: {
            input: {
              tenantId,
              ...input,
            },
          },
        });

        return {
          ...response,
          data: {
            ...response.data,
            createUnderwriterEmployee: response.data?.adminCreateUnderwriterEmployee,
          },
        };
      } else {
        return await createUnderwriterEmployeeAsCustomer({
          variables: {
            input,
          },
        });
      }
    },
    [tenantId, createUnderwriterEmployeeAsAdmin, createUnderwriterEmployeeAsCustomer]
  );

  return {
    createUnderwriterEmployee,
    error: errorAsCustomer ?? errorAsAdmin,
  };
}
